<template>

  <b-container>
    <div class="row">

      <div class="col-md-4 col-sm-12">
        <b-form-group
          :label="dateLabel"
          :label-for="dateId"
          :state="dateConf.date.state"
          :invalid-feedback="dateConf.date.invalidFeedback"
          class="bold-label mb-4">
          <b-form-datepicker
            :id="dateId"
            v-model="dateConf.date.value"
            :state="dateConf.date.state"
            :label-no-date-selected="$t('noDateSelected')"
            :min="minDate">
          </b-form-datepicker>
        </b-form-group>
      </div>

      <div class="col-md-4 col-sm-12">
        <b-form-group
          :label="startTimeLabel"
          :label-for="startTimeId"
          :state="dateConf.startTime.state"
          :invalid-feedback="dateConf.startTime.invalidFeedback"
          class="bold-label mb-4">
          <b-form-timepicker
            :id="startTimeId"
            v-model="dateConf.startTime.value"
            :state="dateConf.startTime.state"
            :label-no-time-selected="$t('noTimeSelected')"
            :label-close-button="$t('timeCloseButton')">
          </b-form-timepicker>
        </b-form-group>
      </div>

      <div v-if="withEndTime" class="col-md-4 col-sm-12">
        <b-form-group
          :label="endTimeLabel"
          :label-for="endTimeId"
          :state="dateConf.endTime.state"
          :invalid-feedback="dateConf.endTime.invalidFeedback"
          class="bold-label mb-4">
          <b-form-timepicker
            :id="endTimeId"
            v-model="dateConf.endTime.value"
            :state="dateConf.endTime.state"
            :label-no-time-selected="$t('noTimeSelected')"
            :label-close-button="$t('timeCloseButton')">
          </b-form-timepicker>
        </b-form-group>
      </div>

    </div>
  </b-container>

</template>

<script >

export default {
  name: 'DateTimeField',

  props: {
    dateConf: {
      type: Object,
      default: null
    },
    minDate: {
      type: Date,
      default: function() {
        return new Date()
      }
    },
    dateId: {
      type: String,
      default: 'date-input'
    },
    dateLabel: {
      type: String,
      default: function () {
        return this.$t('Date')
      }
    },
    startTimeId: {
      type: String,
      default: 'startTime-input'
    },
    startTimeLabel: {
      type: String,
      default: function () {
        return this.$t('StartTime')
      }
    },
    endTimeId: {
      type: String,
      default: 'endTime-input'
    },
    endTimeLabel: {
      type: String,
      default: function () {
        return this.$t('EndTime')
      }
    },
    withEndTime: {
      type: Boolean,
      default: true
    },
  },

  watch: {

    'dateConf.endTime.value': function() {
      this.checkEndTimeValidity()
    },

    'dateConf.startTime.value': function() {
      this.checkEndTimeValidity()
    }

  },

  methods: {

    checkEndTimeValidity() {
      if (this.dateConf.endTime.value < this.dateConf.startTime.value) {
        this.dateConf.endTime.state = false
        this.dateConf.endTime.invalidFeedback = this.$t('endTime.error')
      }
      else {
        this.dateConf.endTime.state = null
        this.dateConf.endTime.invalidFeedback = null
      }
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/DateTimeField.vue